<template>
  <div class="detail-wrapper">

    <Head :title="$tc('header.back')"
          :lanshow="ActiveName" />
    <!-- <NavBar /> -->
    <div class="detail-inner">
      <h5 class="mianbaoxie">
        <span>首页></span><span v-if="dataList && dataList.channel && dataList.channel.name">{{ dataList.channel.name }}></span>
        <span v-if="dataList && dataList.channel && dataList.channel.name">{{
          dataList.channel.name
        }}</span>
      </h5>
      <!-- 标题 -->
      <div class="detail-title">
        <p class="detail-title-p">规划师概括归纳的撒开放改革</p>
        <span class="xiahuaxian"></span>
        <p class="detail-date">2022年04月04日</p>
      </div>
      <!-- 内容 -->
      <div class="detail-neirong">
        <img src="../../assets/img/banner.jpg"
             alt=""
             class="imgs" />
        <div v-html="neirong"
             style="margin-bottom: 5vw"></div>
      </div>
      <Footer />
    </div>
    <!-- <Empty :emptydata="emptydata" v-if="emptydata" /> -->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Detail',
  props: {},
  data () {
    return {
      dataList: null,
      pageSize: 20,
      id: 44,
      emptydata: null,
      neirong: `<p style="color:red">尽快回归康宁地方纳博科夫对方</p> 你不是的看法按八
          九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快<a href="">回归康宁地方纳博科</a>夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁<br/>地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九尽快回归康宁地方纳博科夫对方你不是的看法按八九
        `
    }
  },
  created () {
    this.setShowLoading(false)
    this.getDataList()
    this.id = this.$route.query.id
    // 用户是否登录
    const token =
      localStorage.getItem('userInfo') &&
      JSON.parse(localStorage.getItem('userInfo')) &&
      JSON.parse(localStorage.getItem('userInfo')).token
    if (token) {
      // 显示登陆头像
      this.setActiveName(true)
    } else {
      this.setActiveName(false)
    }
  },
  methods: {
    ...mapMutations(['setShowLoading', 'setActiveName']),
    getDataList () {
      this.$Api
        .getNewsDetail({
          newsId: this.$route.query && this.$route.query.id,
          pageSize: this.pageSize
        })
        .then((data) => {
          if (!data) {
            this.dataList = {
              type: 'nodata'
            }
          } else {
            this.dataList = data
            this.$Common.track('load', {
              name: data.channel && data.channel.name,
              id: this.id,
              type: '资讯'
            })
          }
          this.setShowLoading(false)
        })
        .catch(() => {
          this.emptydata = {
            type: 'nonetwork'
          }
          this.setShowLoading(false)
        })
    }
  },
  computed: {
    ...mapState(['ActiveName'])
  },
  watch: {},
  components: {}
}
</script>

<style lang="scss" scoped>
.detail-title {
  box-sizing: border-box;
  padding: 4vw;
  position: relative;
}
.detail-title-p {
  font-size: 3vw;
  color: aqua;
}
.xiahuaxian {
  position: absolute;
  top: 10vw;
  left: 4vw;
  padding-left: 15vw;
  border-bottom: 1vw solid blue;
}
.detail-date {
  font-size: 1vw;
  margin-top: 7vw;
}
.detail-neirong {
  padding: 3vw;
}
.imgs {
  height: 29vw;
  margin-bottom: 6vw;
}
</style>
